import React from 'react'
import Ctalogo from '../../assets/images/vivek.jpg';
import { Link } from 'react-router-dom';
import Star from '../../assets/images/star-bottom.png'

const Ctaone = () => {
    return (
        <section className="cta-one" style={{ paddingTop: 24 }}>
            <div className="container">
                <div className="text-center mb-4" style={{ marginTop: 32 }}>
                    <h1 style={{ fontWeight: 500, fontSize: '2.5rem', marginBottom: 0, paddingBottom: 0 , lineHeight: "40px"}}>
                        Your NRI affairs, handled with heart and expertise
                    
                    </h1>
                    <img
                         src={Star}
                         className="img-fluid  w-60-mobile w-50"
                         style={{ marginTop: 0, paddingTop: 0, marginBottom: "2em", maxWidth: "60%" }}
                         alt=""
                    />
                <div>    
                    {/* <div style={{
                        width: 170,
                        margin: '12px auto 0 auto',
                        borderBottom: '2px solid #222',
                        position: 'relative',
                        height: 24,
                        display: 'inline',
                    }}/>
                        <span style={{
                            display: 'inline',
                            position: 'absolute',
                            left: '50%',
                            top: -16,
                            transform: 'translateX(-50%)',
                            background: '#fff',
                            padding: '0 12px',
                            fontSize: 24,
                            letterSpacing: 8
                        }}>
                            ★★★
                        </span>
                        <div style={{
                        width: 170,
                        margin: '12px auto 0 auto',
                        borderBottom: '2px solid #222',
                        position: 'relative',
                        height: 24,
                        display: "inline"
                    }}/> */}
                    
                    
                </div>    
                </div>
                <div className="row justify-content-center align-items-start" style={{ marginTop: 34 }}>
                    <div className="col-lg-7 col-md-8 col-12 px-4" style={{ textAlign: 'left' }}>
                        <div style={{ fontSize: 18, lineHeight: 1.7, maxWidth: 700 }}>
                            <p className='mb-3'>
                                <span style={{ fontWeight: 600, fontSize: 22 }}>Dear friends,</span>
                            </p>
                            <p style={{ textAlign: "justify"}}>
                                At The NRI Advisors, our approach to financial consulting goes beyond numbers and strategies. We believe in the power of human connection and the importance of trust in every interaction. As an advisor, my mission is not only to provide expert financial guidance but to build lasting relationships with the individuals and families we serve.
                            </p>
                            <p style={{ textAlign: "justify"}}>
                                The foundation of our work is rooted in understanding that financial decisions are deeply personal. Whether you are navigating a new investment opportunity, planning for retirement, or seeking guidance on tax strategies, we know that these decisions often reflect your values, hopes, and dreams. That’s why we take the time to listen to your unique story, priorities, and challenges. By focusing on your needs first, we ensure that the solutions we provide align with your long-term goals and aspirations.
                            </p>
                            <p style={{ textAlign: "justify"}}>
                                At The NRI Advisors, every touchpoint matters. From your initial consultation to every follow-up, we aim to earn your trust at each step. Our team is committed to being transparent, accessible, and responsive, providing you with the knowledge and support you need to feel confident about your financial decisions. It’s about more than just advising—it’s about fostering a partnership where you feel heard, respected, and supported.
                            </p>
                            <p style={{ textAlign: "justify"}}>
                                We recognize that trust isn’t built overnight. It’s earned through consistent, genuine interactions, and by always putting your interests first. As we work together, we promise to honour the trust you place in us and to be there for you at every stage of your financial journey.
                            </p>
                            <p style={{ textAlign: "justify"}}>
                                Thank you for considering us as your trusted advisors. We look forward to helping you build a secure and prosperous future.
                            </p>
                            <p style={{ fontWeight: 600, marginTop: 32, marginBottom: 0 }}>
                                Warm regards,<br />
                                Vivek Aggarwal<br />
                                <span style={{ fontWeight: 400 }}>Head-India Operations, The NRI Advisors</span>
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-10 d-flex justify-content-center" style={{ minWidth: 320 }}>
                        <img
                            src={Ctalogo}
                            alt="Vivek Aggarwal"
                            style={{
                                width: 320,
                                height: 380,
                                objectFit: 'cover',
                                borderRadius: 4,
                                marginLeft: 24,
                                boxShadow: '0 2px 16px rgba(0,0,0,0.08)'
                            }}
                        />
                    </div>
                </div>
            </div>
        </section>
    )
}
export default Ctaone;